import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { ParameterSideNavPeriodComponent } from './components/parameter-sidenav.period/parameter-sidenav.period.component';
import { TreeviewGroupedComponent } from './components/treeview-grouped/treeview-grouped.component';
import { TreeviewSingleComponent } from './components/treeview-single/treeview-single.component';

import { CheckboxItemComponent } from './components/checkbox-item/checkbox-item.component';
import { CheckboxTreeviewComponent } from './components/checkbox-treeview/checkbox-treeview.component';
import { CheckboxTreeviewEventParser } from './models/checkbox-treeview-event-parser';
import { GetWholeTreeviewEventParser } from "./components/treeview.base";

import { DisplayParamTextDataComponent } from './components/display-param-text-data/display-param-text-data.component';
import { DisplayParamTreeViewDataComponent } from './components/display-param-treeview-data/display-param-treeview-data.component';
import { DisplayParamGroupedTreeViewDataComponent } from './components/display-param-grouped-treeview-data/display-param-grouped-treeview-data.component';

/**
 * Exporterar Tree-view och date-picker-baserade komponenter för att ställa in filter på rapporter.
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        NgbModule //Bootstrap för Angular2 https://ng-bootstrap.github.io/#/getting-started
        ,
        DisplayParamTextDataComponent,
        DisplayParamTreeViewDataComponent,
        DisplayParamGroupedTreeViewDataComponent,
        ParameterSideNavPeriodComponent,
        TreeviewGroupedComponent,
        TreeviewSingleComponent,
        CheckboxItemComponent,
        CheckboxTreeviewComponent
    ],
    exports: [
        DisplayParamTextDataComponent,
        DisplayParamTreeViewDataComponent,
        DisplayParamGroupedTreeViewDataComponent,
        ParameterSideNavPeriodComponent,
        TreeviewGroupedComponent,
        TreeviewSingleComponent,
        CheckboxItemComponent,
        CheckboxTreeviewComponent
    ],
    providers: [
        { provide: CheckboxTreeviewEventParser, useClass: GetWholeTreeviewEventParser }
    ]
})
export class HighChartsParametersComponentsModule {}
